import { useQuery } from "react-query";
import { useAccessToken } from "hooks/useAccessToken";
import { QUERY_STALE_TIME } from "utils/constants";
import queryFn from "ApiLayer/Reports/Baseline/queryBuildingCount";

export const useBuildingCount = (filtersetUid: string | null) => {
    const accessToken = useAccessToken();

    return useQuery({
        queryKey: ["buildingCount", filtersetUid],
        queryFn: async () =>
            queryFn(accessToken, {
                reportFiltersetUid: filtersetUid,
            }),
        staleTime: QUERY_STALE_TIME,
    });
};
